<template>
  <div>
    <router-view />
  </div>

</template>

<script>
  export default {
    name: "casino"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/casino.vue